import colors from 'assets/theme/base/colors';
import rgba from 'assets/theme/function/rgba';
import borders from 'assets/theme/base/borders';
import pxToRem from 'assets/theme/function/px-to-rem';

const { borderRadius } = borders;

const globals = {
    html: {
        height: '100%',
        backgroundColor: 'linear-gradient(90deg, #1E252B 0%, #21103E 100%)',
        '*::-webkit-scrollbar': {
            width: '0.5em',
            height: '0.5em',
        },
        '*::-webkit-scrollbar-thumb': {
            backgroundColor: rgba(colors.action.scroll, 0.5),
            //outline: '1px solid slategrey',
            borderRadius: borderRadius.xl,
        },
    },
    body: {
        height: '100%',
        backgroundColor: 'linear-gradient(90deg, #1E252B 0%, #21103E 100%)',
    },

    filterOpened: {
        display: 'flex !important',
        flexWrap: 'wrap',
        gap: pxToRem(10),
        justifyContent: 'flex-start',
    },

    '#root': {
        height: '100%',
    },

    '*, *::before, *::after': {
        margin: 0,
        padding: 0,
    },
};

export default globals;
